import { TableCell, Typography } from "@crayon/design-system-react";

interface TableHeaderCellProps {
  columnName: string;
  colSpan?: number;
  width?: string;
}
const TableHeaderCell = ({ columnName, colSpan = 1, width }: TableHeaderCellProps) => (
  <TableCell colSpan={colSpan} size="small" width={width}>
    <Typography variant="subtitle2">{columnName}</Typography>
  </TableCell>
);

export default TableHeaderCell;
